var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pagina-de-entrada" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "pagina-de-entrada__container pagina-de-entrada__container_secundario",
        attrs: { tabindex: "2" }
      },
      [
        _c("div", { staticClass: "pagina-de-entrada__conteudo-do-container" }, [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "form",
            {
              staticClass:
                "formulario formulario_medio u-margem-inferior-grande",
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.efetuarAutenticacao($event)
                }
              }
            },
            [
              _c("div", { staticClass: "grade__linha" }, [
                _c(
                  "label",
                  {
                    attrs: { "aria-label": "Informe o seu CPF no campo abaixo" }
                  },
                  [_vm._v("Seu CPF")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.camposParaLogin.cpf,
                      expression: "camposParaLogin.cpf"
                    },
                    {
                      name: "mask",
                      rawName: "v-mask",
                      value: "###.###.###-##",
                      expression: "'###.###.###-##'"
                    }
                  ],
                  staticClass: "formulario__input",
                  attrs: {
                    id: "cpf",
                    required: "",
                    type: "tel",
                    "aria-label":
                      "Insira aqui o número do seu CPF com 11 dígitos",
                    tabindex: "2"
                  },
                  domProps: { value: _vm.camposParaLogin.cpf },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.camposParaLogin, "cpf", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "grade__linha u-margem-superior-pequena" },
                [
                  _c(
                    "label",
                    {
                      attrs: {
                        "aria-label":
                          "Informe a sua data de nascimento no campo abaixo"
                      }
                    },
                    [_vm._v("Data de nascimento")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.camposParaLogin.dataDeNascimento,
                        expression: "camposParaLogin.dataDeNascimento"
                      },
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: "##/##/####",
                        expression: "'##/##/####'"
                      }
                    ],
                    staticClass: "formulario__input",
                    attrs: {
                      id: "data",
                      required: "",
                      type: "tel",
                      placeholder: "DD/MM/AAAA",
                      tabindex: "2",
                      "aria-label":
                        "Informe a sua data de nascimento com 8 dígitos"
                    },
                    domProps: { value: _vm.camposParaLogin.dataDeNascimento },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.camposParaLogin,
                          "dataDeNascimento",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "grade__linha u-margem-superior-pequena" },
                [
                  _c(
                    "label",
                    {
                      attrs: {
                        "aria-label":
                          "Informe o número do contrato no campo abaixo"
                      }
                    },
                    [_vm._v("Número de contrato")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "botao botao_sem-preenchimento botao_mini botao_cor-primaria",
                      attrs: { type: "button" },
                      on: { click: _vm.exibirModal }
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-info-circle",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v(" Onde encontrar?\n              ")
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.camposParaLogin.numeroDeContrato,
                        expression: "camposParaLogin.numeroDeContrato"
                      },
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: "########",
                        expression: "'########'"
                      }
                    ],
                    staticClass: "formulario__input",
                    attrs: {
                      id: "numeroDeContrato",
                      required: "",
                      tabindex: "2",
                      "aria-label": "Informe o número do contrato com 8 dígitos"
                    },
                    domProps: { value: _vm.camposParaLogin.numeroDeContrato },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.camposParaLogin,
                          "numeroDeContrato",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "botao botao_grande botao_cor-primaria botao_largura-total u-margem-superior-media",
                  attrs: {
                    "aria-label": "Aperte enter para entrar no sistema",
                    type: "submit",
                    tabindex: "2"
                  }
                },
                [_vm._v("Entrar")]
              ),
              _vm._v(" "),
              _vm.mensagensDeErro.naoPossuiFinanciamento
                ? _c(
                    "div",
                    {
                      staticClass: "mensagem mensagem_cor-erro",
                      attrs: { role: "alert" }
                    },
                    [
                      _c("i", {
                        staticClass: "far fa-times-circle mensagem__icone"
                      }),
                      _vm._v(" "),
                      _vm._m(2)
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.mensagensDeErro.financiamentoEstaBloqueado
                ? _c(
                    "p",
                    {
                      staticClass:
                        "mensagem_aviso-beneficiario mensagem_cor-erro"
                    },
                    [
                      _vm._v(
                        " Este financiamento encontra-se bloqueado. Por favor, entre em contato com a AGEHAB para maiores informações."
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("modal-informacao-do-numero-de-contrato", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.deveExibirModal,
                    expression: "deveExibirModal"
                  }
                ],
                on: { fecharModal: _vm.fecharModal }
              })
            ],
            1
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "pagina-de-entrada__container pagina-de-entrada__container_primario",
        attrs: { tabindex: "1" }
      },
      [
        _c(
          "div",
          {
            staticClass: "pagina-de-entrada__conteudo-do-container",
            attrs: { tabindex: "1" }
          },
          [
            _c("img", {
              staticClass: "logos-do-sistema",
              attrs: {
                src:
                  "/Administracao/Content/images/boleto-online/logo-governo.svg",
                alt:
                  " Agência de Habitação Popular do Estado de Mato Grosso do Sul"
              }
            }),
            _vm._v(" "),
            _c(
              "h3",
              {
                staticClass: "titulo titulo_gigante",
                attrs: { tabindex: "1" }
              },
              [_vm._v("Emissão de boleto online.")]
            ),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "texto_medio u-margem-inferior-media",
                attrs: { tabindex: "1" }
              },
              [
                _vm._v(
                  "Emita seu boleto pelo nosso site de forma prática, segura e sem custos. Para acessar, preencha seus dados nos campos ao lado."
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "texto_medio u-margem-inferior-media",
                attrs: { tabindex: "1" }
              },
              [
                _c("strong", [
                  _vm._v(" Serviço de Atendimento ao Público - SAP")
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\n        pelo telefone 0800-647-3120, das 8 às 13 horas.\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c("p", { staticClass: "texto_medio", attrs: { tabindex: "1" } }, [
              _c("strong", [_vm._v("Campo Grande: ")]),
              _vm._v("Nos postos de atendimento situados nos Fáceis.\n      ")
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass:
                  "botao botao_medio botao_primaria botao_invertido u-margem-superior-media",
                attrs: {
                  href: "http://www.agehab.ms.gov.br/agehab/atendimento/",
                  target: "_blank",
                  tabindex: "1"
                }
              },
              [_vm._v("Encontre um Fácil perto de você")]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "pagina-de-entrada__logo-digix",
            attrs: {
              href: "http://www.digix.com.br/",
              target: "blank",
              tabindex: "3"
            }
          },
          [
            _c("img", {
              attrs: {
                src:
                  "https://habix.agehab.ms.gov.br/seguranca/Content/imagens/logo-digix-roxo.png",
                alt: "Acesso ao site Digix"
              }
            })
          ]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { tabindex: "2" } }, [
      _c(
        "h2",
        {
          staticClass:
            "titulo titulo_grande titulo_cor-primaria u-margem-inferior-pequena"
        },
        [_vm._v("Emita seu boleto aqui!")]
      ),
      _vm._v(" "),
      _c("p", [_vm._v("Para iniciar, informe os dados abaixo:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mensagem__conteudo" }, [
      _c("h2", { staticClass: "mensagem__titulo" }, [
        _vm._v("Identificamos um erro:")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mensagem__texto" }, [
        _vm._v("Nenhum financiamento encontrado com estes dados.")
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-495ba2f2", { render: render, staticRenderFns: staticRenderFns })
  }
}